/** @format */
import { toSnakeCase } from '@toucan/common/helpers/change-case';
import { SearchFacet } from '@toucan/common/services/search/constants';
import { getSearchParamKey } from '@toucan/common/services/search/helpers';
import { SelectedFilters } from '@toucan/common/services/search/types';

import { SearchParam } from '@toucan/client/global/nextjs';

import { FilterOption } from '@toucan/client/features/search/components/model-search-results/types';

function transformFilterQueryToSearchParams(
    selectedFilters: SelectedFilters
): SearchParam {
    return Object.entries({ ...selectedFilters }).reduce(
        (searchParams: SearchParam, [key, value]) => {
            const searchParamKey = getSearchParamKey(key);

            searchParams[searchParamKey] = value;

            return searchParams;
        },
        {}
    );
}

function getSelectedItems(selectedItems: FilterOption[]): string[] | undefined {
    if (selectedItems.length === 0) {
        return;
    }

    return selectedItems.map((item: FilterOption) => item.value.toString());
}

export function transformFiltersToSearchParams(
    filter: { id: SearchFacet },
    selectedItems: FilterOption[],
    selectedFilters: SelectedFilters
): SearchParam {
    const additionalQuery: Record<string, string> = {};

    const variant = selectedItems.find((item) => item.variant)?.variant;

    if (variant) {
        const searchParamsFilterKey = toSnakeCase(filter.id);
        additionalQuery[`variant_${searchParamsFilterKey}`] = variant;
    }

    const searchParams = transformFilterQueryToSearchParams(selectedFilters);

    const searchParamKey = getSearchParamKey(filter.id);

    searchParams[searchParamKey] = getSelectedItems(selectedItems);

    return { ...searchParams, ...additionalQuery };
}
